import { JudgeCard } from "@components/cards/JudgeCard"
import { ChipGroup } from "@components/controls/ChipGroup"
import { RichSelect } from "@components/controls/RichSelect"
import { SearchBox } from "@components/controls/SearchBox"
import { DirectoryHeader } from "@components/layout/DirectoryHeader"
import { ResultList, ResultListMode } from "@components/layout/ResultList"
import { StaggerTransitionRoot } from "@components/motion/Transition"
import { useJury } from "@hooks/queries"
import { useSearchParams } from "eddev/routing"
import { defineView } from "eddev/views"
import { useMemo } from "react"

export const meta: ViewMeta = {
  templateName: "Judge Listing",
}

export default defineView("archive-judge", (props) => {
  const years = useMemo(() => {
    return (
      props.page?.judgeListing?.yearsToShow
        ?.map((n) => n?.info?.awardYear!)
        ?.filter(Boolean)
        .sort()
        .reverse() ?? []
    )
  }, [props.page])

  const [params, filter] = useSearchParams({
    category: [] as string[],
    year: years[0] as number | undefined,
    display: "row" as ResultListMode,
    search: "",
  })

  const results = useJury({
    year: params.year,
    category: params.category,
    search: params.search,
  })

  const categories = useMemo(() => {
    return props.page?.judgeListing?.yearsToShow?.find((y) => y?.info?.awardYear === params.year)?.judgeCategories?.sort((a, b) => a?.name?.localeCompare(b?.name!)!) ?? []
  }, [props.page, params.year])

  const items = useMemo(() => {
    const items = results.data?.judges?.nodes ?? []
    items.sort((a, b) => a.title?.localeCompare(b.title!)!)
    // items.sort((a, b) => a.judgeInfo?.category?.[0]?.name?.localeCompare(b.judgeInfo?.category?.[0]?.name!)!)
    return items
  }, [results.data])

  return (
    <StaggerTransitionRoot>
      <DirectoryHeader
        heading="Jury"
        displayMode="row"
        // displayMode={params.display}
        // onDisplayModeChange={filter.setter("display")}
        tags={
          <div className="stack-x-1 flex-wrap max-w-[800px]">
            {years.length > 1 && (
              <RichSelect
                size="chip"
                variant="outline"
                value={String(params.year)}
                onChange={(val) => filter.set("year", parseInt(val))}
                options={years.map((year) => ({
                  label: String(year),
                  value: String(year),
                }))}
              />
            )}
            <ChipGroup unwrapped value={params.category} onValueChange={filter.setter("category")} options={categories.map((b) => ({ value: b?.slug!, label: b?.name! }))} />
          </div>
        }
        search={<SearchBox onSearch={filter.setter("search")} placeholder="Search judges..." />}
      />
      <ResultList
        mode={params.display}
        items={items}
        hasNextPage={false}
        loading={results.isLoading}
        loadingNextPage={false}
        // onFetchMore={useCallback(() => lookup.fetchNextPage(), [lookup])}
        component={JudgeCard}
        dynamicSizing={false}
        keyField="id"
        mobileMode="row"
      />
      <div className="h-10" />
    </StaggerTransitionRoot>
  )
})
